import BrowserSupport from './BrowserSupport'

export default BrowserSupport
